<template lang="html">
  <div>
    <!-- filtros -->
    <md-layout md-gutter="16" md-row style="margin:10px">
      <md-layout md-flex="100" style="margin-bottom: 10px">
        <md-input-container style="margin:auto; width:100%" >
          <label>Buscar</label>
          <md-input v-model="bySubstring" @keyup.enter.native="getArticulos(1)"></md-input>
        </md-input-container>
      </md-layout>
      <md-layout md-flex-xlarge="20"
            md-flex-large="20"
            md-flex-medium="25"
            md-flex-small="100"
            md-flex-xsmall="100"
            v-if="parametros.departamento == 1">
        <md-input-container>
          <label for="departamento">{{parametros.departamento_descr}}</label>
          <md-select name="departamento" id="departamento" v-model="idDepartamento">
            <md-option :value="''" >Todos</md-option>
            <md-option :value="departamento.idinterno" v-for="departamento in departamentos" @selected="setSubDepartamentos(departamento)">{{departamento.descripcion}}</md-option>
          </md-select>
        </md-input-container>
      </md-layout>
      <md-layout md-flex-xlarge="20"
            md-flex-large="20"
            md-flex-medium="25"
            md-flex-small="100"
            md-flex-xsmall="100"
            v-if="parametros.subdepto == 1">
        <md-input-container>
          <label>{{parametros.subdepto_descr}}</label>
          <md-select name="subdepartamento" id="subdepartamento" v-model="idsubDepto">
            <md-option :value="''" >Todos</md-option>
            <md-option :value="subdepartamento.idinterno" v-for="subdepartamento in subdepartamentos">{{subdepartamento.descripcion}}</md-option>
          </md-select>
        </md-input-container>
      </md-layout>
      <md-layout md-flex-xlarge="20"
            md-flex-large="20"
            md-flex-medium="25"
            md-flex-small="100"
            md-flex-xsmall="100"
            v-if="parametros.categoria == 1">
        <md-input-container>
          <label for="categoria">{{parametros.categoria_descr}}</label>
          <md-select name="categoria" id="categoria" v-model="idCategoria">
            <md-option :value="''" >Todas</md-option>
            <md-option :value="categoria.idinterno" v-for="categoria in categorias">{{categoria.descripcion}}</md-option>
          </md-select>
        </md-input-container>
      </md-layout>
      <md-layout md-flex-xlarge="20"
            md-flex-large="20"
            md-flex-medium="25"
            md-flex-small="100"
            md-flex-xsmall="100"
            v-if="parametros.tipoproducto == 1">
        <md-input-container>
          <label>{{parametros.tipoproducto_descr}}</label>
          <md-select name="tipo" id="tipo" v-model="idtipoproducto">
            <md-option :value="''" >Todos</md-option>
            <md-option :value="tipo.idinterno" v-for="tipo in tiposProducto">{{tipo.descripcion}}</md-option>
          </md-select>
        </md-input-container>
      </md-layout>
      <md-layout md-flex-xlarge="20"
            md-flex-large="20"
            md-flex-medium="25"
            md-flex-small="100"
            md-flex-xsmall="100" md-align="center">
        <md-button class="md-accent" @click.native="getArticulos(1)">Filtrar </md-button>
      </md-layout>
        <!-- <md-layout md-flex="33">
            <md-input-container>
                <label for="">Año</label>
                <md-autocomplete
                :id="'Categoria'"
                v-model="filtros.ano"
                name="categoria"
                data-vv-name="categoria"
                :fetch="getCategoria"
                :min-chars="2"
                printAttribute="descripcion"
                queryParam="descripcion"
                :prepareResponseData="prepareResponseData"
                @selected="setCategoria"/>
            </md-input-container>
        </md-layout> -->
        <!-- <md-layout md-flex="10">
          <div>
            <md-button class="md-primary md-raised" @click.native="filter">filtrar </md-button>
          </div>
        </md-layout> -->
<!-- catalogo -->
    </md-layout>
    <md-card v-if="articulos.length === 0 && parametros" style="height:100px">
      <md-layout md-align="center center">
        <div class="md-title" style="padding:25px">No se encontraron Articulos</div>
      </md-layout>
    </md-card>
    <md-layout md-gutter="16" md-row>
        <md-layout
            md-flex-xlarge="20"
            md-flex-large="20"
            md-flex-medium="33"
            md-flex-small="100"
            md-flex-xsmall="100"
            v-for="(articulo, index) in articulos" 
            v-if="articulo.precio > 0"
            :ref="index"
            :key="index"
            >
        <md-card class="articulo-card">
            <md-card-header>
                    <md-card-header-text>
                      <div class="md-subhead">{{articulo.clave}}</div>
                      <div class="md-title" style="min-height:80px; max-height:80px; font-size:14px">
                        <!-- {{articulo.descripcion}} -->
                        {{articulo.descripcion.substring(0, 100)}} {{articulo.descripcion.trim().length > 100 ? '...' : ''}}
                        <md-tooltip>
                          {{articulo.descripcion}}
                        </md-tooltip>
                      </div>
                    </md-card-header-text>

                </md-card-header>

                <md-card-media style="min-height:150px; margin-top:25px">
                    <md-layout md-align="center" style="padding:10px;">
                        <!-- <img id="" :src="articulo.foto" :alt="articulo.foto" /> -->
                        <img :id="`img${index}`" v-if="articulo.foto && articulo.foto.replace(/ /g,'') !== '' && articulo.foto.replace(/ /g,'') !== null" :src="`${parametros.ruta_imagen}${articulo.foto}`"  style="z-index:99"/>
                        <img id="" v-else src="../../assets/img/SuperticketElefanteC.png" alt="No se encontro la imagen" style="z-index:99"/>
                    </md-layout>
                </md-card-media>

                <md-card-content>
                    <md-layout class="descripcion">
                    {{articulo.observacion}}
                    </md-layout>
                    <md-layout md-align="end" style="">
                      <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100" v-if="parametros.ocultar_precios == 0 || isLogged">
                        <md-input-container>
                          <label>Cantidad</label>
                          <md-input v-model="articulo.cantidad"
                            type="number"
                            min="1"
                            maxlength="5"></md-input>
                        </md-input-container>
                      </md-layout>
                      <md-layout md-align="end" md-flex="100">
                        <label class="precioNormal"   v-if="parametros.ocultar_precios == 0 || isLogged">
                            <span v-show="articulo.oferta">{{articuloPrecio(articulo.precioAnt)}}                   </span>
                        </label>
                      </md-layout>
                      <md-layout md-align="end">
                        <label class="precio" v-if="parametros.ocultar_precios == 0 || isLogged">
                            {{articuloPrecio(articulo.precio)}}                   
                        </label>
                      </md-layout>
                    </md-layout>
                  <md-layout md-align="end">
                    <div class="existencia" v-if="parametros.existencia_negativa === '0' && articulo.servicio == false">
                      <div class="agotado" v-if="parseFloat(articulo.existencia) <= 0">AGOTADO</div>
                      <div class="disponible" v-else>DISPONIBLE</div>
                    </div>
                  </md-layout>
                  <md-layout md-flex="100" md-align="end">
                    <md-button class="md-accent" @click.native="openDetalles(articulo)">Detalles</md-button>
                    <md-button style="margin-right:0px" class="md-primary md-raised" @click.native="setArticulo(articulo)" v-if ="parametros.ocultar_precios === 0 || parametros.ocultar_precios === '0' || isLogged">Agregar </md-button>
                  </md-layout>
                </md-card-content>
                <md-card-actions>
                </md-card-actions>
            </md-card>
        </md-layout>
    </md-layout>
<!-- articulo detalles -->
    <md-dialog ref="dialogDetalle" id="dialogDetalle" v-if="articuloSeleccionado">
      <md-dialog-title style="padding:0">
        <md-toolbar>
          <div class="md-title">Detalle del artículo</div>
        </md-toolbar>
      </md-dialog-title>
      <md-dialog-content>
        <md-layout>
          <md-layout style="width:300px; padding:20px">
            <img style="max-height:200px;" :id="`img${index}`" 
              v-if="articuloSeleccionado.foto && articuloSeleccionado.foto.replace(/ /g,'') !== '' && articuloSeleccionado.foto.replace(/ /g,'') !== null" :src="`${parametros.ruta_imagen}${articuloSeleccionado.foto}`" />
            <img style="max-height:200px;" id="" v-else src="../../assets/img/SuperticketElefanteC.png" alt="No se encontro la imagen" />
          </md-layout>
          <md-layout md-column md-flex-small="100" md-flex-xsmall="100">
            <div v-if="!parametros.existencia_negativa === '0' && !articuloSeleccionado.servicio == 'false'">En existencia: {{articuloSeleccionado.existencia}}</div>
            <h2 style="font-size:16px;">{{articuloSeleccionado.descripcion}}</h2>
            <p style="text-align: justify;min-height:200px">{{articuloSeleccionado.observacion}}</p>            
            <md-layout md-align="end">
              <label class="precio" v-if="parametros.ocultar_precios == 0 || isLogged">
                {{articuloPrecio(articuloSeleccionado.precio)}}
              </label>
            </md-layout>
          </md-layout>
        </md-layout>
        <md-layout md-row md-gutter="16" v-if="secundarias.length > 0">
          <md-layout md-flex="100" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label for="">Color y talla</label>
              <md-select
                id="colorSlct"
                tabindex="8"
                required
                v-model="idSecundaria"
                @selected="setIdSecundaria()">
                <md-option v-for="secundaria in secundarias" :value="secundaria.idinterno">
                  {{secundaria.color}} {{secundaria.talla.replace(/ /g,'') !== '' ? `- ${secundaria.talla}` : ''}}
                </md-option>
              </md-select>
            </md-input-container>
          </md-layout>
        </md-layout>  
        <md-layout md-row>
          <md-layout md-flex md-flex-small="100" md-flex-xsmall="100">
            <md-radio :disabled="articuloSeleccionado.presentacion2 === null || articuloSeleccionado.presentacion2.replace(/ /g,'') === ''" v-model="presentacion" class="md-primary" id="my-test1" name="my-test-group1" md-value="1"
            v-if="articuloSeleccionado.presentacion1" @change="precioStshopPresentacion(articuloSeleccionado, 1)">{{articuloSeleccionado.presentacion1}}</md-radio>
          </md-layout>
           <md-layout md-flex md-flex-small="100" md-flex-xsmall="100">
            <md-radio v-model="presentacion" class="md-primary" id="my-test2" name="my-test-group1" md-value="2"
             v-if="articuloSeleccionado.presentacion2 && articuloSeleccionado.presentacion2.replace(/ /g,'') !== ''" @change="precioStshopPresentacion(articuloSeleccionado, 2)">{{articuloSeleccionado.presentacion2}}</md-radio>
          </md-layout>
          <md-layout md-flex md-flex-small="100" md-flex-xsmall="100">
            <md-radio v-model="presentacion" class="md-primary" id="my-test3" name="my-test-group1" md-value="3"
             v-if="articuloSeleccionado.presentacion3 && articuloSeleccionado.presentacion2.replace(/ /g,'') !== ''" @change="precioStshopPresentacion(articuloSeleccionado, 3)">{{articuloSeleccionado.presentacion3}}</md-radio>
          </md-layout>
        </md-layout>
        <md-layout md-row v-if="parametros.ocultar_precios == 0 || isLogged">
          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Cantidad</label>
              <md-input v-model="cantidad"
                type="number"
                @change.native="calculateTotal"
                min="1"
                maxlength="5"></md-input>
            </md-input-container>
          </md-layout>
          <md-layout md-flex="50" md-align="end" md-flex-small="100" md-flex-xsmall="100">
            <label class="precio">
            Total:    {{toMoney(articuloSeleccionado.precio * cantidad)}}
            </label>
          </md-layout>
        </md-layout>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-accent" @click.native="closeDetalles">Cancelar</md-button>

        <md-button v-if="parametros.existencia_negativa === '0' && articuloSeleccionado.servicio == 'false'" :disabled="secundarias.length > 0 && idSecundaria === null || articuloSeleccionado.existencia < cantidad" class="md-primary md-raised" @click.native="addToCart">
          Agregar
          <md-tooltip v-if="secundarias.length > 0 && idSecundaria === null">
            Debes seleccionar color y talla
          </md-tooltip>
        </md-button>

        <md-button v-else :disabled="(secundarias.length > 0 && idSecundaria === null) || !(parametros.ocultar_precios == 0 || isLogged)" class="md-primary md-raised" @click.native="addToCart">
          Agregar
          <md-tooltip v-if="secundarias.length > 0 && idSecundaria === null">
            Debes seleccionar color y talla
          </md-tooltip>
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-pagination v-if="articulos.length > 0" @PAGINATION_GO_PAGE="getArticulos" :pagination="pagination"/>
  </div>
</template>

<script type="text/javascript">
  import mdAutocomplete from '../../shared-components/autocomplete/mdAutocomplete';
  import mdPagination from '../../shared-components/pagination/pagination';
  import { toMoney } from '../../common/functions/helpers';
  import { prepareResponseData } from '../../common/functions/http';

  export default {
    name: 'Inicial',
    data() {
      return {
        resourceArticulos: this.$api.articulo(this.$resource),
        resourceDepartamentos: this.$api.departamento(this.$resource),
        resourceCategorias: this.$api.categoria(this.$resource),
        resourceTipoProducto: this.$api.tipoProducto(this.$resource),
        resourceCliente: this.$api.cliente(this.$resource),
        pagination: {},
        filtros: {
          stshop: 1,
        },
        idCategoria: '',
        idDepartamento: '',
        idsubDepto: '',
        idtipoproducto: '',
        categoria: '',
        tipo: '',
        articuloSeleccionado: {},
        presentacion: 1,
        idSecundaria: null,
        secundarias: [],
        cantidad: 1,
        articulos: [],
        articulos2: [],
        idDepartamento: '',
        categorias:[],
        tiposProducto: [],
        departamentos: [],
        subdepartamentos: [],
        parametros: {},
        bySubstring:'',
        isLogged: false,
      };
    },
    beforeRouteUpdate(to) {
      // this.filtros.idDepartamento = to.params.idDepartamento;
      // this.filtros.idsubDepto = to.params.idSubDepartamento;
      // this.bySubstring = to.params.descripcion;
      // this.getArticulos(1);
    },
    components: {
      mdAutocomplete,
      mdPagination,
    },
    computed: {
      orderByPrice: function() {
        return this.articulos.sort(function (a, b) {
          if (a.precio < b.precio) {
            return 1;
          }
          if (a.precio > b.precio) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      }
    },
    watch: {
    },
    methods: {
      toMoney,
      prepareResponseData,
      getDepartamentos() {
        this.resourceDepartamentos.buscar()
          .then((response) => {
            this.departamentos = response.data.data;
          })
          .catch((err) => {
            this.$error(this, err);
          });
      },
      getParametros() {
        this.resourceCliente.parametros()
          .then((response) => {
            const parametros = {};
            response.body.data.forEach((el) => {
              switch (el.descripcion.trim()) {
                case 'almacen':
                  parametros.almacen = el.parametro.trim();
                  break;
                case 'pago':
                  parametros.pago = el.parametro.trim();
                  break; 
                case 'envio':
                  parametros.envio = el.parametro.trim();
                  break;
                case 'ruta_imagen':
                  parametros.ruta_imagen = el.parametro.trim();
                  break;
                case 'existencia_negativa':
                  parametros.existencia_negativa = el.parametro.trim();
                  break;
                case 'sitio':
                  parametros.sitio = el.parametro.trim();
                  break;
                case 'subdepto_descr':
                  parametros.subdepto_descr = el.parametro.trim();
                  break;
                case 'categoria':
                  parametros.categoria = el.parametro.trim();
                  break; 
                case 'categoria_descr':
                  parametros.categoria_descr = el.parametro.trim();
                  break;
                case 'tipoproducto':
                  parametros.tipoproducto = el.parametro.trim();
                  break;
                case 'tipoproducto_descr':
                  parametros.tipoproducto_descr = el.parametro.trim();
                  break;
                case 'ano':
                  parametros.ano = el.parametro.trim();
                  break;
                case 'ano_descr':
                  parametros.ano_descr = el.parametro.trim();
                  break;
                case 'departamento':
                  parametros.departamento = el.parametro.trim();
                  break; 
                case 'departamento_descr':
                  parametros.departamento_descr = el.parametro.trim();
                  break;
                case 'subdepto':
                  parametros.subdepto = el.parametro.trim();
                  break;
                case 'envio_por_cobrar':
                  parametros.envio_por_cobrar = el.parametro.trim();
                  break; 
                case 'metodo_envio':
                  parametros.metodo_envio = el.parametro.trim();
                  break;
                case 'porcentaje_envio':
                  parametros.porcentaje_envio = el.parametro.trim();
                  break; 
                case 'articulo_envio':
                  parametros.articulo_envio = el.parametro.trim();
                  break; 
                case 'ocultar_precios':
                  parametros.ocultar_precios = el.parametro.trim();
                  break;   
                case 'pagos_meses':
                  parametros.pagos_meses = el.parametro.trim();
                  break; 
              }
            })
            localStorage.setItem('parametros', JSON.stringify(parametros));
            this.parametros = parametros;
            if (this.articulos) {
              this.articulos.map((articulo) => {
                articulo.precio = this.precioStshop(articulo);
                articulo.existencia = this.getExistencia(articulo.existencias)
              })
            }
          })
          .catch((err) => {
            this.$error(this, err);
          });
      },
      setIdSecundaria() {
        this.articuloSeleccionado.idsecundaria = this.idSecundaria;
      },
      setSubDepartamentos(departamento) {
        this.subdepartamentos = departamento.subdepartamentos;
        this.idsubDepto = '';
      },
      precioStshopPresentacion(articulo, presentacion) {
        let precio = '';
        const usuario = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : {};
        let idlistaprecio = usuario.cliente && usuario.cliente.idlistaprecio && usuario.cliente.idlistaprecio.trim() !== ''  ? usuario.cliente.idlistaprecio : 'STSHOP    ';
        if (articulo.precios) {
          this.articuloSeleccionado.precio = 0;
          while (this.articuloSeleccionado.precio == 0 || this.articuloSeleccionado.precio == undefined){
             
          articulo.precios.forEach((element) => {
            if (element.idlistaprecio === idlistaprecio) {
              if (this.articuloSeleccionado) {
                this.articuloSeleccionado.id_presentacion = presentacion;
                this.articuloSeleccionado.pIeps = articulo.ieps ? (articulo.ieps.porcentaje / 100) + 1 : 1;
                this.articuloSeleccionado.pIva = articulo.iva ? (articulo.iva.porcentaje / 100) + 1 : 1;  
                switch(presentacion) {
                  case 1:                     
                    this.articuloSeleccionado.precioN = articulo.oferta ? parseFloat(articulo.ofertaStShop).toFixed(2) :  parseFloat(element.precio1).toFixed(2); 
                    this.articuloSeleccionado.precio = (parseFloat(element.precio1).toFixed(2) * parseFloat(this.articuloSeleccionado.pIeps).toFixed(2)) * parseFloat(this.articuloSeleccionado.pIva).toFixed(2); 
                    break;
                  case 2: 
                    this.articuloSeleccionado.precioN = parseFloat(element.precio2).toFixed(2);
                    this.articuloSeleccionado.precio = (parseFloat(element.precio2).toFixed(2) * parseFloat(this.articuloSeleccionado.pIeps).toFixed(2)) * parseFloat(this.articuloSeleccionado.pIva).toFixed(2); 
                    break;
                  case 3: 
                    this.articuloSeleccionado.precioN = parseFloat(element.precio3).toFixed(2);
                    this.articuloSeleccionado.precio = (parseFloat(element.precio3).toFixed(2) * parseFloat(this.articuloSeleccionado.pIeps).toFixed(2)) * parseFloat(this.articuloSeleccionado.pIva).toFixed(2); 
                    break;
                  default: 
                    this.articuloSeleccionado.precioN = articulo.oferta ? parseFloat(articulo.ofertaStShop).toFixed(2) :  parseFloat(element.precio1).toFixed(2); 
                    this.articuloSeleccionado.precio = (parseFloat(element.precio1).toFixed(2) * parseFloat(this.articuloSeleccionado.pIeps).toFixed(2)) * parseFloat(this.articuloSeleccionado.pIva).toFixed(2);
                }
                if (this.articuloSeleccionado.precio == 0){
                  idlistaprecio = 'STSHOP    ';
                }
              }
            }
          });
        }
        }
      },
      getExistencia(existencias){
        let existencia = '';
        existencias.forEach((element) => {
          if (element.idalmacen === this.parametros.almacen) {
            existencia = element.existencia
          }
        });
        return existencia;
      },
      getPrecio(articulo, idlistaprecio, oferta){
        let precio = "";
        if(!oferta){
          articulo.precios.forEach(element => {
            if (element.idlistaprecio === idlistaprecio) {
              const ieps = articulo.ieps ? articulo.ieps.porcentaje / 100 + 1 : 1;
              const iva = articulo.iva ? articulo.iva.porcentaje / 100 + 1 : 1;
              const precioIeps = parseFloat(element.precio1).toFixed(2) * ieps;
              precio =
                parseFloat(precioIeps).toFixed(2) *
                iva *
                articulo.moneda.cotizacion;
            }
          });
        } else {
          const ieps = articulo.ieps ? articulo.ieps.porcentaje / 100 + 1 : 1;
              const iva = articulo.iva ? articulo.iva.porcentaje / 100 + 1 : 1;
              const precioIeps = parseFloat(articulo.ofertaStShop).toFixed(2) * ieps;
              precio =
                parseFloat(precioIeps).toFixed(2) *
                iva *
                articulo.moneda.cotizacion;
        }
        return precio;
      },
      precioStshop(articulo, oferta) {
        let precio = '';
        
        const usuario = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : {};
        let idlistaprecio = usuario.cliente && usuario.cliente.idlistaprecio ? usuario.cliente.idlistaprecio : 'STSHOP    ';

        if (articulo.precios) {
          precio = this.getPrecio(articulo, idlistaprecio, oferta);
          if (idlistaprecio !== 'STSHOP    ' && (precio === '' || precio === 0)){
            idlistaprecio = 'STSHOP    ';
            precio = this.getPrecio(articulo, idlistaprecio, oferta);
          }
        }
        return precio;
      },
        filtrosStr(filtros) {
        if(this.idCategoria !== ''){
          filtros.idCategoria = this.idCategoria;
        } else {
          delete filtros.idCategoria
        }
        if(this.idDepartamento !== ''){
          filtros.idDepartamento = this.idDepartamento;
        } else {
          delete filtros.idDepartamento
        }
        if(this.idsubDepto !== ''){
          filtros.idsubDepto = this.idsubDepto;
        } else {
          delete filtros.idsubDepto
        }
        if(this.idtipoproducto !== ''){
          filtros.idtipoproducto = this.idtipoproducto;
        } else {
          delete filtros.idtipoproducto
        }
        return JSON.stringify(filtros).replace(/"|{|}/g,'');
      },
      getCategoria() {
        const descripcion = this.categoria;
        this.resourceCategorias.buscar({ descripcion })
          .then((response) => {
            this.categorias = response.data.data;
          })
      },
      getTipo() {
        const descripcion = this.tipo;
        this.resourceTipoProducto.buscar({ descripcion })
          .then((response) => {
            this.tiposProducto = response.data.data;
          })
      },
      articuloPrecio(precio) {
        if (precio) {
          return toMoney(parseFloat(precio, 10)); 
        }
        return 0.00;
      },
      setCategoria(categoria, value) {
        this.filtros.idCategoria = categoria.idinterno.replace(/ /g,'');
        this.getArticulos(1);
      },
      setTipo(tipo, value) {
        this.filtros.idtipoproducto = tipo.idinterno.replace(/ /g,'');
        this.getArticulos(1);
      },
      openDetalles(articulo) {
        // this.presentacion = 1;
        // this.color = null;
        // this.talla = null;
        // this.cantidad = 1;
        // this.getArticulo(articulo.idinterno);
        // this.getSecundarias(articulo.idinterno);
        // this.$refs.dialogDetalle.open();
        window.location.href = this.parametros.sitio + "/articulo/" + articulo.idinterno;
      },
      closeDetalles() {
        this.$refs.dialogDetalle.close();
      },
      calculateTotal() {
        this.cantidad = this.cantidad < 1 ? 1 : this.cantidad;
        this.articuloSeleccionado.precioTotal = (this.cantidad * parseFloat(this.articuloSeleccionado.precioN).toFixed(2)) * this.articuloSeleccionado.moneda.cotizacion;
        this.articuloSeleccionado.impuestos = this.cantidad * (parseFloat(this.articuloSeleccionado.precio).toFixed(2) - (parseFloat(this.articuloSeleccionado.precioN).toFixed(2)) * this.articuloSeleccionado.moneda.cotizacion);
      },
      addToCart() {
        if(this.articuloSeleccionado.existencia < this.cantidad && this.parametros.existencia_negativa === '0' && this.articuloSeleccionado.servicio == false){
          this.$toast.create('Lamentablemente no contamos con la cantidad de articulos seleccionados', 'snack', 3E3);
          return;
        }
        const cart = window.cart ? window.cart : [];
        this.articuloSeleccionado.cantidad = this.cantidad;
        this.articuloSeleccionado.presentacion = this.presentacion;
        this.calculateTotal();
        cart.push(this.articuloSeleccionado);
        window.cart = cart;
        localStorage.setItem('cart', JSON.stringify(cart));
        this.idSecundaria = null;
        this.closeDetalles();
        this.$toast.create('Articulo agregado al carrito', 'snack', 3E3);
        this.$root.$emit('setcart', cart);
      },
      getArticulo(idArticulo) {
        this.resourceArticulos.buscarById({ idArticulo })
          .then((response) => {
            try {
              this.articuloSeleccionado = response.body;
              // this.getSecundarias(this.articuloSeleccionado.idinterno);
              this.precioStshopPresentacion(this.articuloSeleccionado);
              this.articuloSeleccionado.id_presentacion = 1;
              this.articuloSeleccionado.precio = this.precioStshop(this.articuloSeleccionado)
              this.articuloSeleccionado.existencia= this.getExistencia(this.articuloSeleccionado.existencias)
            } catch (e) {
              alert(e);
            }
            
          })
          .catch((err) => {
            this.$error(this, err);
          });
      },   
      setArticulo(articulo){
        this.cantidad = articulo.cantidad;
        this.articuloSeleccionado = articulo;
        this.articuloSeleccionado.cantidad = this.cantidad;
        this.articuloSeleccionado.precio = 0;
        this.precioStshopPresentacion(articulo);
        this.articuloSeleccionado.id_presentacion = 1;
        this.articuloSeleccionado.precio = this.precioStshop(this.articuloSeleccionado, this.articuloSeleccionado.oferta)
        this.addToCart();
      },
      getArticulos(page) {
        if (this.bySubstring && this.bySubstring.toUpperCase() === 'NUBIA'){
          alert("Te Amo mi Nubis! <3 ");
        } else{
        const filtros = this.filtrosStr(this.filtros);
        this.resourceArticulos.buscar( { page, filtros, bySubstring: this.bySubstring })
          .then((response) => {
            // this.filtros.idDepartamento = '';
            // // $route.params.idDepartamento = '';
            // this.filtros.idsubDepto = '';
            // // $route.params.idSubDepartamento = '';
            // this.bySubstring = '';
            // $route.params.descripcion = '';
            
            this.articulos = response.data.data;
            this.pagination = response.data.meta;
            if (localStorage.getItem('parametros')) {
              this.articulos.map((articulo) => {
                articulo.oferta = articulo.ofertaStShop !== null && articulo.ofertaStShop !== '' && parseFloat(articulo.ofertaStShop) !== 0 && articulo.ofertaStShop !== undefined;
                articulo.precioAnt = this.precioStshop(articulo, false);
                articulo.precio = this.precioStshop(articulo, articulo.oferta);
                articulo.existencia = this.getExistencia(articulo.existencias);
                articulo.cantidad = 1;
              })

            }
          })
          .catch((err) => {
            this.$error(this, err);
          });
        }
      },
      getSecundarias(idArticulo) {
        
        this.resourceArticulos.buscarSecundaria( { idArticulo })
          .then((response) => {
            
            this.secundarias = response.data.data;
          })
          .catch((err) => {
            this.$error(this, err);
          });
      },
      filter() {
        this.$router.replace({ name: 'inicial', params: {}});
      },
    },
    mounted() {
      this.bySubstring = this.$route.query.descripcion;
      this.idDepartamento = this.$route.query.departamento;
      this.getParametros();
      this.getArticulos(1);
      this.getCategoria();
      this.getTipo();
      this.getDepartamentos();
      this.isLogged = localStorage.getItem('cliente') ? true : false;
      localStorage.setItem("ultimaPagina", 'inicial'); 
    },
  };
</script>
<style lang="scss">
    .articulo-card{
        margin:10px;
        width:100%;
        img{
           max-height: 130px;
           max-width: 130px;
           
        }
        .descripcion {
            // height:215px;
            text-align: justify;
            height:70px;
            margin-bottom:10px;
            .md-tooltip{
                max-width: 100px !important;
            }
        }
        .md-card-actions{
            
        }
    }
    #dialogDetalle{
      .md-dialog{
        width:650px;
        }
    }
    .precio{
      font-size: 18px;
      font-weight: bold;
      opacity: .8;
      margin-top: 20px;
    }
    .existencia {
      font-size:14px;
      font-weight: 500;
      text-align: center;
      // margin-right: auto;
      padding: 5px 0px;
      .agotado{
        // background-color: #FF0000;
        color:#FF0000;

      }
      .disponible{
        // background-color: #01DF01;
        color:#04B431;

      }

    }
</style>



// WEBPACK FOOTER //
// src/spa/catalogo/catalogo.vue